import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import Backend from 'i18next-http-backend';
import LanguageDetector from "i18next-browser-languagedetector";
import intervalPlural from "i18next-intervalplural-postprocessor";
import translationEN from './data/localization/en/translate.json';
import translationFR from './data/localization/fr/translate.json';
const resources = {
    'en': {
        translation: translationEN
    },
    'fr-CA': {
        translation: translationFR
    }
};
i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(intervalPlural)
    .use(initReactI18next)
    .init({
        debug: false,
        compatibilityJSON: 'v3',
        resources,
        // lng:"fr-CA",
        fallbackLng: 'en',
        //nsSeparator: ':::',
        //keySeparator: '::',
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false,
            wait: false,
        },
        detection: {
            // Options for language detection
            order: ['navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage', 'cookie'],
            // You can customize further if needed
          }
    });
export default i18n;